<template>
  <div class="client-app">
    <div class="client-app-inc">
        <LeftSide v-if="!isMobile"></LeftSide>
        <div class="score-content" v-show="!scoreModal && isMobile || !isMobile">
            <div class="item" v-for="x in 6" :key="x">
                <div class="event">
                    <div class="icon">
                        <img src="https://ls.sportradar.com/ls/crest/big/2936.png">
                    </div>
                    <div class="info">
                        <h3>20 TL ÖDÜL !</h3>
                        <p>Yangon United - Juventus</p>
                        <small>02/26 23:00</small>
                    </div>
                    <div class="icon">
                        <img src="https://ls.sportradar.com/ls/crest/medium/40025.png">
                    </div>
                </div>
                <div class="bet">
                  <div class="row">
                    <div class="col col-2 bet-input">
                      <div class="inline-form">
                        <label v-if="!isMobile">Yangon United</label>
                        <input :placeholder="isMobile ? 'Ev Skoru' : ''" :type="isMobile ? 'tel' : 'number'">
                      </div>
                    </div>
                    <div class="col col-1" v-if="!isMobile">
                      <div class="inline-form">
                        <div class="vs">VS</div>
                      </div>
                    </div>
                    <div class="col col-2 bet-input">
                      <div class="inline-form">
                        <label v-if="!isMobile">Juventus</label>
                        <input :placeholder="isMobile ? 'Deplasman Skoru' : ''"  :type="isMobile ? 'tel' : 'number'">
                      </div>
                    </div>
                    <div class="col col-5 bet-button">
                      <div class="inline-form">
                        <label v-if="!isMobile"><br></label>
                        <button class="button primary block">Tahmin Yap</button>
                      </div>
                    </div>
                    <div class="col col-2 bet-rule">
                      <div class="inline-form">
                        <label v-if="!isMobile"><br></label>
                        <button class="button secondary block" @click="openModal">Koşullar</button>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
        <div class="promo-modal">
          <Modal @modalStatus="scoreModal = $event" :isPromotion="true" :isVisible="scoreModal">
            <template slot="title">Yangon United - Juventus</template>
            <template slot="slogan">Tahmin Yap 30 TL Kazan !</template>
            <template slot="img"><img src="https://resmim.net/f/5g5Ln6.jpg" style="object-fit:none;" width="400" height="200"></template>
            <template slot="info">
                  <div class="slogan">
                    <div class="well">
                      <span>1</span>
                      Üye Girişinizi Yapın
                    </div>
                    <div class="well">
                      <span>2</span>
                      Tahmininizi Yapın
                    </div>
                    <div class="well">
                      <span>3</span>
                      30 TL Ödülün Sahibi  Olun!
                    </div>
                  </div>
            </template>
            <template slot="content">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Modi animi eligendi ab quia porro vitae, exercitationem eius sequi nesciunt, doloribus illo dolor, veritatis voluptas asperiores nobis sint. Iusto, quos magni?
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Modi animi eligendi ab quia porro vitae, exercitationem eius sequi nesciunt, doloribus illo dolor, veritatis voluptas asperiores nobis sint. Iusto, quos magni?</p>
            </template>
          </Modal>
        </div>
    </div>
  </div>
</template>

<script>
  import LeftSide from '../components/Score/LeftSide'
  export default{
    data(){
      return{
        scoreDetail:{},
        scoreModal: false,
      }
    },
    metaInfo () {
      return {
        title: 'Skor Tahmin | ' + _.get(this.$store.getters['getClientMeta'], 'main.title', ''),
      }
    },
    methods:{
      openModal(){
        this.scoreModal = true;
      }
    },
    components:{
      LeftSide,
    }
  }

</script>